<div class="tab-content">
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
        <div class="hero-text" style="margin-left: 10px;">
            <h1 style="font-weight: 800;">{{'CAR'|translate}} {{this.operation=='create'?('CREATE'|translate):('UPDATE'|translate)}}</h1>
        </div>
        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'PLATE'|translate}}</mat-label>
            <input matInput placeholder="{{'PLATE'|translate}}" name="plate" [(ngModel)]="model.plate" required>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'FUEL_PER_MINUTE'|translate}}</mat-label>
            <input matInput type="number" placeholder="{{'FUEL_PER_MINUTE'|translate}}" name="fuelPerMinute" [(ngModel)]="model.fuelPerMinute" required>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'FUEL_PER_KM'|translate}}</mat-label>
            <input matInput type="number" placeholder="{{'FUEL_PER_KM'|translate}}" name="fuelPerKm" [(ngModel)]="model.fuelPerKm" required>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'IMEI'|translate}}</mat-label>
            <input matInput type="text" placeholder="{{'IMEI'|translate}}" name="imei" [(ngModel)]="model.imei" required>
        </mat-form-field>

        <mat-form-field *ngIf="companyId==1" appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'COMPANY'|translate}}</mat-label>
            <mat-select [(ngModel)]="selectedCompany" placeholder="{{'COMPANY'|translate}}" (ngModelChange)="polygonList()" required name="companies">
                <mat-option *ngFor="let item of companyList" name="copaniesOptions" [value]="item.id">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'REGION'|translate}}</mat-label>
            <mat-select [(ngModel)]="model.polygonId" placeholder="{{poligons.length!=0?('REGION'|translate):('ATTACHED_REGION_NOT_FOUND'|translate)}}" required name="poligons">
                <mat-option *ngFor="let item of poligons" name="options" [value]="item.id">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <button mat-raised-button (click)="save()">
            <span>{{'CREATE'|translate}}</span>
        </button>
    </form>
</div>